import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Icon, LegalConsent } from '@carrent/ui'
import { useLoginForm, DEMO_ACCOUNTS, useLegal, fetchLegalDocument } from '@carrent/domain'
import { navigation } from '@carrent/platform'

const DRIVER_APP_URL = import.meta.env.VITE_DRIVER_APP_URL || 'https://app.carflow.site'

export default function LoginPage() {
  const navigate = useNavigate()
  const [showDemo, setShowDemo] = useState(false)
  const { legal } = useLegal()

  // Водительское приложение всегда ведёт на свою главную,
  // независимо от роли: администратор тоже может быть за рулём.
  const form = useLoginForm((user) => {
    // Водитель, попавший в консоль, уходит на своё приложение —
    // это другой хост, поэтому внешний переход, а не router.
    if (user.role === 'admin' || user.role === 'manager') {
      navigate('/admin', { replace: true })
    } else {
      navigation.replaceLocation(DRIVER_APP_URL)
    }
  })

  return (
    <div className="auth-screen auth-screen--console">
      <div className="auth-brand">
        <span className="auth-brand__mark" aria-hidden="true">
          <Icon name="car" size={34} />
        </span>
        <h1 className="auth-brand__title">CarRent</h1>
        <p className="auth-brand__subtitle">Панель управления</p>
      </div>

      <form className="auth-form flex-col gap" onSubmit={form.submit}>
        <div className="field">
          <label className="field__label" htmlFor="phone">
            Телефон
          </label>
          <input
            id="phone"
            className="input"
            type="tel"
            inputMode="tel"
            autoComplete="username"
            placeholder="+7 900 000-00-00"
            value={form.phone}
            onChange={(e) => form.setPhone(e.target.value)}
            aria-invalid={Boolean(form.error)}
          />
        </div>

        <div className="field">
          <label className="field__label" htmlFor="password">
            Пароль
          </label>
          <input
            id="password"
            className="input"
            type="password"
            autoComplete="current-password"
            value={form.password}
            onChange={(e) => form.setPassword(e.target.value)}
            aria-invalid={Boolean(form.error)}
          />
        </div>

        {form.error && (
          <div className="alert alert--error" role="alert">
            {form.error}
          </div>
        )}

        <button type="submit" className="btn btn--primary btn--full" disabled={form.loading}>
          {form.loading ? <span className="spinner spinner--sm" /> : null}
          {form.loading ? 'Входим…' : 'Войти'}
        </button>

        <p className="auth-hint">Доступ выдаёт администратор</p>

        <LegalConsent legal={legal} fetchDocument={fetchLegalDocument} />
      </form>

      {/* Панель существует только в dev-сборке: DEMO_ACCOUNTS
          вычисляется через import.meta.env.DEV и в проде пуст. */}
      {DEMO_ACCOUNTS.length > 0 && (
        <div className="auth-demo">
          <button
            type="button"
            className="btn btn--ghost btn--sm"
            onClick={() => setShowDemo((v) => !v)}
            aria-expanded={showDemo}
          >
            {showDemo ? 'Скрыть' : 'Показать'} тестовые учётки
          </button>

          {showDemo && (
            <div className="auth-demo__list">
              {DEMO_ACCOUNTS.map((a) => (
                <button
                  key={a.phone}
                  type="button"
                  className="chip"
                  onClick={() => form.prefill(a)}
                >
                  {a.label}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
